import { connect } from "react-redux";
import CommunicationPlanRow from "./CommunicationPlanRow";
import {
  sortCommunicationPlansRequest,
  updateCommunicationFlag,
} from "../../../../../store/actions/communications.actions";

const mapDispatchToProps = {
  sortCommunicationPlansRequest,
  updateFlag: updateCommunicationFlag,
};

const mapStateToProps = (state) => {
  // const statusLoading = communicationPlanStatusLoading(state);
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CommunicationPlanRow);
